<div class="app-body">
    <!--App sidebar-->
    <mat-drawer-container class="h-100">
        <mat-drawer mode="side" opened class="sidenav-drawer">
            <!-- Sidebar header-->
            <div class="d-flex align-items-center justify-content-center sidenav-footer-header h-120">
                <img src="../assets/img/outlive-chat.svg" alt="outlive" width="120">
            </div>

            <!--Sidebar content-->
            <div class="side-nav-content" style="margin: 50px;">
                <a class="d-flex align-items-center mb-3  text-white" [routerLink]="['/people']" [ngClass]="{active: ['/people', '/update-people', '/add-people'].includes(router.url) }" href="#">
                    <span class="sidenav-icons"><mat-icon>group</mat-icon></span>
                    <span class="mx-3">People</span>
                </a>
                <a class="d-flex align-items-center mb-3  text-white" [routerLink]="['/analytics']" [ngClass]="{active: router.url == '/analytics' }" href="#">
                    <span class="sidenav-icons"><mat-icon>stacked_line_chart</mat-icon></span>
                    <span class="mx-3">Analytics</span>
                </a>
                <a class="d-flex align-items-center mb-3  text-white" [routerLink]="['/content']" [ngClass]="{active: router.url == '/content' }" href="#">
                    <span class="sidenav-icons"><mat-icon>edit_note</mat-icon></span>
                    <span class="mx-3">Content</span>
                </a>
                <a class="d-flex align-items-center mb-3  text-white" [routerLink]="['/demographic-data']" [ngClass]="{active: router.url == '/demographic-data' }" href="#">
                    <span class="sidenav-icons"><mat-icon>support_agent</mat-icon></span>
                    <span class="mx-3">Demographic Data</span>
                </a>
                <a class="d-flex align-items-center mb-3  text-white" [routerLink]="['/banners']" [ngClass]="{active: router.url == '/banners' }" href="#">
                    <span class="sidenav-icons"><mat-icon>campaign</mat-icon></span>
                    <span class="mx-3">Banners</span>
                </a>
                <a class="d-flex align-items-center mb-3  text-white" [routerLink]="['/language-content']" [ngClass]="{active: ['/language-content'].includes(router.url) || router.url.startsWith('/language-detail') }" href="#">
                    <span class="sidenav-icons"><mat-icon>translate</mat-icon></span>
                    <span class="mx-3">Language Content</span>
                </a>
            </div>
            <!-- Sidebar footer -->
            <div class="sidenav-footer-header d-grid w-100" style="position:absolute;bottom:0;">
                <div class="admin-profile row align-items-center h-55" (click)="router.navigate(['/profile'])">
                    <div class="col-2 px-4">
                        <span class="sidenav-icons"><mat-icon>manage_accounts</mat-icon></span>
                    </div>
                    <div class="col-8 pl-4 font-13">
                        <div class="ellipsis cursor">Admin Profile</div>
                        <div class="ellipsis cursor" data-toggle='tooltip' title="{{serviceManager.email}}">{{serviceManager.email}}</div>
                    </div>
                    <div class="col-1 pl-1">
                        <span><mat-icon>keyboard_arrow_right</mat-icon></span>
                    </div>
                </div>
                <hr class="my-1">
                <div class="row cursor signout text-white align-items-center h-40">
                    <div class="col-2 px-4"></div>
                    <div class="col pl-4 font-13" (click)="serviceManager.logoutUser()">Sign Out</div>
                </div>
            </div>
        </mat-drawer>
        <mat-drawer-content class="mat-drawer-content ng-star-inserted" style="margin-left: 250px;"></mat-drawer-content>
    </mat-drawer-container>
</div>